export const redistributionPageStateSchema = {
    ui: {
        type: 'object',
        properties: {
            redistributeLocationIds: {
                type: 'array',
                items: { type: 'number' },
                default: []
            },
            filterText: {
                type: 'string',
                default: ''
            },
            redistributeFilterText: {
                type: 'string',
                default: ''
            },
            syncBricklink: {
                type: 'boolean',
                default: true,
                persist: true
            },
            showExecuteConfirm: {
                type: 'boolean',
                default: false
            },
            excludeContainerTypeIds: {
                type: 'array',
                items: { type: 'number' },
                default: []
            },
            bulkConfig: {
                type: 'object',
                default: { mode: 'empty', target_pct: 80 },
                persist: true
            }
        }
    }
};
